class ScrollToTop extends HTMLElement{
    connectedCallback(){
        this.addEventListener("click", () => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        });

        this.showButton();

        document.addEventListener("scroll", () => {
            this.showButton();
        });
        if(document.querySelector('sticky-add-to-cart')){
            if(this.classList.contains("pos-right")){
                this.classList.remove("pos-right");
                this.classList.add("pos-left");
            }
        }
    }

    showButton(){
        if(document.body.scrollTop > 20 || document.documentElement.scrollTop > 20){
            this.classList.add("active");
        }
        else{
            if(this.classList.contains('active')){
                this.classList.remove("active");
            }
        }
    }
}

customElements.get("scroll-to-top") || customElements.define("scroll-to-top", ScrollToTop);